module.exports = __webpack_public_path__ + "static/img/53gradennoord.1240d16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/53gradennoord.jpg
// module id = 123
// module chunks = 0